import { Component, Shark, Utils } from "shark-mvc";
import { Modal } from "bootstrap";

import TextContent from "../../models/TextContent";

import templateContent from "./auto-related-contents-suggestion.html";

import contentsManager from "../../controllers/contentsManager";
import waitBoxComponent from "../waitBox/waitBoxComponent";
import ImageContent from "../../models/ImageContent";

class AutoRelatedContentSuggestionComponent extends Component {
	constructor () {
		super("autoRelatedContentSuggestionComponent");
		this.addTemplate("", templateContent);
	}

	afterRender () {
		this.modal = Modal.getOrCreateInstance(document.querySelector("#autoRelatedContentSuggestionModal"));
	}

	addRelatedContent (targetContent) {
		const { autoRelatedContentSuggestionData, autoRelatedTextContentSuggestion } = Shark.get();

		if (autoRelatedContentSuggestionData.suggestedContentIndexes.length > 0) {
			autoRelatedTextContentSuggestion.forEach(content => {
				if (autoRelatedContentSuggestionData.suggestedContentIndexes.includes(content._index.toString())) {
					if (!targetContent.relatedContents.find(item => item.guid === content.guid)) {
						targetContent.relatedContents.push({
							guid: content.guid,
							title: content.title,
							type: content.type,
						});

						targetContent.__renderableRelatedContent.push(content);
					}
				}
			});

			autoRelatedContentSuggestionData.set({ suggestedContentIndexes: [] });
		}
	}

	autoRelatedContentSuggestionModalSelectAllBtn_clickHandler () {
		const { autoRelatedTextContentSuggestion, autoRelatedContentSuggestionData } = Shark.get();
		
		autoRelatedContentSuggestionData.set({
			suggestedContentIndexes: autoRelatedTextContentSuggestion.map(item => item._index.toString()),
		});

		Shark.render();
	}

	autoRelatedContentSuggestionModalDeselectAllBtn_clickHandler () {
		const { autoRelatedContentSuggestionData } = Shark.get();

		autoRelatedContentSuggestionData.set({
			suggestedContentIndexes: [],
		});

		Shark.render();
	}

	autoRelatedContentSuggestionModalInvertSelectionBtn_clickHandler () {
		const { autoRelatedTextContentSuggestion, autoRelatedContentSuggestionData } = Shark.get();
		
		const mario = autoRelatedTextContentSuggestion.filter(item => !autoRelatedContentSuggestionData.suggestedContentIndexes.includes(item._index.toString())).map(item => item._index.toString());

		autoRelatedContentSuggestionData.set({
			suggestedContentIndexes: mario,
		});

		Shark.render();
	}

	autoRelatedContentSuggestionModalAcceptBtn_clickHandler () {
		const { currContent } = Shark.get();

		if (currContent) {
			this.addRelatedContent(currContent);
			Shark.render();
			this.emit("contentAdded");
		}

		this.close();
	}

	autoRelatedContentSuggestionModalCancelBtn_clickHandler () {
		const { autoRelatedContentSuggestionData} = Shark.get();

		autoRelatedContentSuggestionData.set({ suggestedContentIndexes: [] });
		Shark.render();
		
		this.close();
	}

	autoRelatedContentSuggestionUpdateSearchBtn_clickHandler () {
		const { autoRelatedContentSuggestionData } = Shark.get();

		autoRelatedContentSuggestionData.set({
			forceRange: true,
		});

		this.retrieveSuggestedRelatedContent(null, autoRelatedContentSuggestionData.lastSearchContentType);
	}

	close () {
		this?.modal?.hide();
	}

	init () {
		this.addComponents([waitBoxComponent]);

		const autoRelatedContentSuggestionData = Shark.getInstance("__smart__", {
			forceRange: false,
			lastSearchContentType: [],
			maxPageNumber: 0,
			minPageNumber: 0,
			suggestedContentIndexes: [],
			onDataChanged: (data) => console.log(data),
		});

		Shark.set({
			autoRelatedContentSuggestionData,
			autoRelatedTextContentSuggestion: [],
		});
	}
	
	open () {
		this?.modal?.show();
	}

	async retrieveSuggestedRelatedContent (currContent, contentType = ["text"]) {
		if (!currContent) {
			currContent = Shark.get("currContent");
		}
		
		if (currContent) {
			const key = currContent.tags.filter(item => item.value.slice(0, 3) === "pag")?.[0]?.value;

			if (key && key.trim() !== "") {
				waitBoxComponent.open();

				const { autoRelatedContentSuggestionData } = Shark.get();

				const currContentBasePage = parseInt(key.slice(3));
				const currContentVolumeName = currContent.referenceVolumes?.[0].value;

				let rangeStartPage = currContentBasePage - 1;
				let rangeEndPage = currContentBasePage + 1;
				
				autoRelatedContentSuggestionData.set({
					lastSearchContentType: contentType,
				});

				if (autoRelatedContentSuggestionData.forceRange) {
					rangeStartPage = autoRelatedContentSuggestionData.minPageNumber;
					rangeEndPage = autoRelatedContentSuggestionData.maxPageNumber;
				}
				else {
					autoRelatedContentSuggestionData.set({
						maxPageNumber: rangeEndPage,
						minPageNumber: rangeStartPage,
					});
				}

				console.log({currContent, key, currContentVolumeName, autoRelatedContentSuggestionData});

				const filters = {
					advancedSearch: ["tagInternal", "tagReferenceVolumes"/*, "textsTitle", "textsSubtitle", "textsAbstract", "textsDescription", "textsImageAuthor", "textsImageFileName", "textsImageSource", "textsImageDates"*/],
					contentType,
					searchType: ["texts", "tags"],
					searchKey: key,
				};

				const autoRelatedContentSuggestionGuids = new Set();
				const autoRelatedContentAllSuggestion = [];

				
				for (let page = rangeStartPage; page <= rangeEndPage; page++) {
					filters.searchKey = "pag" + (page).toString().padStart(3, "0");
					// console.log("filters.searchKey page", filters.searchKey);
					const currPageResults = await contentsManager.searchWithFullResponse(filters);
					let currPageImageContentList = Shark.getInstanceList(ImageContent, currPageResults?.data?.images);
					let currPageTextContentList = Shark.getInstanceList(TextContent, currPageResults?.data?.texts);
					
					currPageImageContentList
					.filter(item => item.guid !== currContent.guid && item.referenceVolumes.filter(volume => volume.value === currContentVolumeName).length > 0)
					.forEach(item => autoRelatedContentSuggestionGuids.add(item.guid));

					currPageTextContentList
					.filter(item => item.guid !== currContent.guid && item.referenceVolumes.filter(volume => volume.value === currContentVolumeName).length > 0)
					.forEach(item => autoRelatedContentSuggestionGuids.add(item.guid));

					// console.log(currPageImageContentList);
					// console.log(currPageTextContentList);
					// console.log(autoRelatedContentSuggestionGuids);
					
					
					autoRelatedContentAllSuggestion.push(...currPageImageContentList.filter(item => autoRelatedContentSuggestionGuids.has(item.guid)));
					autoRelatedContentAllSuggestion.push(...currPageTextContentList.filter(item => autoRelatedContentSuggestionGuids.has(item.guid)));

					// console.log(autoRelatedContentSuggestion);
				}

				const autoRelatedContentSuggestion = [];

				autoRelatedContentAllSuggestion.forEach(item => {
					if (!autoRelatedContentSuggestion.find(present => present.guid === item.guid)) {
						autoRelatedContentSuggestion.push(item);
					}
				});
				

				Utils.reindexList(autoRelatedContentSuggestion);

				Shark.set({
					autoRelatedTextContentSuggestion: autoRelatedContentSuggestion,
				});

				autoRelatedContentSuggestionData.set({
					forceRange: false,
				});

				waitBoxComponent.close();
				
				this.open();
			}
			else {
				alert("Non c'è la pagina di riferimento in questo contenuto, non posso proseguire.");
			}
		}
	}

	suggestRelatedContentBtn_clickHandler () {
		this.retrieveSuggestedRelatedContent();
	}
}

const autoRelatedContentSuggestionComponent = new AutoRelatedContentSuggestionComponent();

Shark.registerComponent(autoRelatedContentSuggestionComponent);

export default autoRelatedContentSuggestionComponent;
